module.exports = __webpack_public_path__ + "img/Singapore-4.1ed15465.jpg";